import { Inputs, validationSchema } from "@/entities/Coupons/CouponsFormInputs";

const Coupons = {
  Plural: "Coupons",
  Single: "Coupon",
  Inputs: Inputs,
  ValidationSchema: validationSchema,
  UpdateMethod: "post",
  UpdateIdKey: "couponId",
  TransformDataToSend: (payload, _shortCutMapToSend, results) => {
    const bets = Array.isArray(results.bets) ? results.bets : [];
    const mappedBets = bets
      .map((bet) => {
        const betIdValue =
          bet?.betId ?? bet?.betID ?? bet?.id ?? bet?.gameID ?? bet?.gameProviderID;
        const betId = Number(betIdValue);
        const statusId = Number(bet?.statusId);
        return {
          betId: Number.isNaN(betId) ? betIdValue : betId,
          statusId: Number.isNaN(statusId) ? bet?.statusId : statusId,
        };
      })
      .filter((bet) => bet?.betId !== "" && bet?.betId !== undefined && bet?.betId !== null);

    const statusId = Number(results.statusId);
    return {
      statusId: Number.isNaN(statusId) ? results.statusId : statusId,
      bets: mappedBets,
    };
  },
};

export default Coupons;
